import React from 'react';
import { Label, SubLabel } from './StyledLabels';

export const LabelWithSubLabel = ({ label, subLabel, required }) => (
  <>
    <Label isRequired={required}>{label}</Label>
    <SubLabel>{subLabel}</SubLabel>
  </>
);
